<template>
<v-list class='mt-0 pa-0' three-line style='padding-top:0px;' dense>
    <slot></slot>
    <template v-for='invoice in invoices' >
      <invoice-list-item
          @clicked='$emit("selected", invoice)'
          :key='`item-${invoice.id}`'
          :class="{ 'light-blue lighten-5': isSelected(invoice) }"
          :withStatus='withStatus'
          :withStatusBorder='withStatusBorder'
          :invoice='invoice' >
          <v-list-tile-action
            v-if='actions.length > 0'
            slot='actionsBefore'
            class='thin' >

            <v-btn icon
              @click.stop='setSelectedInvoice(invoice)' >
              <v-icon>more_vert</v-icon>
            </v-btn>

          </v-list-tile-action>
          <v-list-tile-action
            v-if='primaryAction'
            slot='actionsAfter' >
            <v-btn icon @click="$emit('primarycta', invoice)"  >
              <v-icon >{{primaryAction.icon}}</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action v-else slot='actionsAfter' >
            <strong class='subheading mt-3' >{{ getAmountDue(invoice) }}</strong>
            <v-list-tile-action-text>Due</v-list-tile-action-text>
          </v-list-tile-action>
      </invoice-list-item>
      <v-divider :key='`div-${invoice.id}`'></v-divider>
    </template>
    <v-list-tile v-if='invoices && invoices.length === 0' >
      <v-list-tile-content >
          <span v-if='!loading' >No invoices found</span>
          <span v-else>
            <v-progress-circular :size='10' :width='1' small indeterminate class="amber--text"></v-progress-circular>
            loading ..
          </span>
    </v-list-tile-content>
    </v-list-tile>

    <v-bottom-sheet scrollable v-model='bottomsheet' >

      <!-- <span v-if="selectedInvoice && selectedInvoice.id" v-text="selectedInvoice.id" /> -->

      <template v-if="selectedInvoice && selectedInvoice.id" >
        <v-subheader class='grey lighten-4 overline py-0 my-0' >
          <v-icon class='mr-2' >post_add</v-icon>
          {{selectedInvoice.title}}
          <v-btn small flat icon target="_blank"
            v-if="viewUrl" :href="viewUrl" >
            <v-icon small >open_in_new</v-icon>
          </v-btn>

          <v-btn small flat :outline="sheetWindow===0" @click="sheetWindow=0" class="ml-3" color="primary" >Actions</v-btn>
          <v-btn small flat :outline="sheetWindow===1" @click="sheetWindow=1" color="primary" >Appointments</v-btn>

          <v-spacer/>
          <v-chip v-if='selectedInvoice.status'
            class='v-chip--x-small' :color="statusColor" text-color="white"
            style='padding:0px 5px;;margin:0px;float:right' label>{{selectedInvoice.status.toUpperCase()}}
          </v-chip>
          <v-btn small icon @click='closeBottomSheet' >
            <v-icon small >close</v-icon>
          </v-btn>
        </v-subheader>
        <v-divider />

        <v-window v-model="sheetWindow" vertical touchless >
          <v-window-item >
            <v-list>
              <v-list-tile
                v-for='action in actions'
                :key='action.icon'
                :disabled="action.disableIf && action.disableIf(selectedInvoice)"
                @click='$root.$emit(action.action, selectedInvoice);bottomsheet=false'
                icon >
                <v-list-tile-title @click='$emit(action.action, selectedInvoice)' >
                  <v-icon>{{action.icon}}</v-icon> {{ action.text }}
                  </v-list-tile-title>
              </v-list-tile>
            </v-list>

          </v-window-item >

          <v-window-item >

            <v-card >
              <v-card-text class="pa-0" style="overflow-y:auto;height:550px;" >
                <invoice-payments
                  :invoice='selectedInvoice'
                  :transactions='selectedInvoice.transaction_set' >

                  <template slot="subheader" >
                    <v-btn small outline
                      color="primary" class="ml-4"
                      :disabled="!selectedInvoice"
                      :loading="requests.enrich.loading"
                      @click="refreshInvoice" >
                        Update invoice
                        <help-popover small class="ml-2" >
                          Click to update the appointments on this invoice.<br/>
                          Changes below are on the appointments attached to this invoice.<br/>
                          Make sure to click this button to update your invoice to reflect any changes made below.
                        </help-popover>
                    </v-btn>
                    <span
                      v-if="requests.enrich.status === 200"
                      class="caption success--text" >
                      <v-icon small >check</v-icon> Invoice updated
                    </span>
                  </template>

                </invoice-payments>
              </v-card-text>
            </v-card>

          </v-window-item>

        </v-window>
      </template>
    </v-bottom-sheet>
</v-list>
</template>

<script>
import InvoiceListItem from '@/components/invoice/InvoiceListItem'
import AppointmentList from '@/components/lists/AppointmentList.vue'
import InvoicePayments from '@/components/invoice/InvoicePayments'
import HelpPopover from '@/components/ui/HelpPopover.vue'
// import * as Sentry from '@sentry/browser'

export default {
  name: 'InvoiceList',
  components: {InvoiceListItem, AppointmentList, InvoicePayments, HelpPopover},
  props: {
    invoices: { type: Array, default: () => { return [] } },
    selectedInvoiceIds: { type: Array, default: () => { return [] } },
    actions: { type: Array, default: () => { return [] } },
    loading: { default: true },
    withStatus: { type: Boolean, default: false },
    withStatusBorder: { type: Boolean, default: false },
    primaryAction: { type: Object },
    colVizExpansion: {}
  },
  data () {
    return {
      selectedInvoice: null,
      bottomsheet: false,
      sheetWindow: 0,
      requests: {
        enrich: {
          resource: 'invoiceguru.invoices',
          resourceId: null,
          method: 'post',
          extra: 'enrich'
        }
      }
    }
  },
  computed: {
    isXs () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    statusColor () {
      if (this.selectedInvoice) {
        if (this.selectedInvoice.status === 'paid') { return 'success' }
        if (this.selectedInvoice.status === 'sent') { return 'primary' }
      }
      return 'blue-grey lighten-4'
    },
    viewUrl () {
      if (this.selectedInvoice && this.selectedInvoice.get_view_url) {
        let base = this.$invoiceguru.baseUrl
        return `${base}${this.selectedInvoice.get_view_url}`
      }
      return null
    }
  },
  methods: {
    isSelected (invoice) {
      if (!this.selectedInvoiceIds) { return false }
      return this.selectedInvoiceIds.indexOf(invoice.id) !== -1
    },
    closeBottomSheet () {
      this.bottomsheet = false
    },
    setSelectedInvoice (invoice) {
      this.selectedInvoice = invoice
      this.bottomsheet = false
      window.setTimeout(() => {
        this.bottomsheet = true
        this.sheetWindow = 0
      }, 100)
    },
    getAmountDue (invoice) {
      let due = invoice.total_due
      if (invoice.status === 'paid') {
        if (invoice.total_due > 0) {
          due = 0
        }
      } else {
        let calcDue = (invoice.invoice_amount - invoice.amount_paid)
        if (parseFloat(calcDue) !== parseFloat(due)) {
          due = calcDue
        }
      }
      return this.formatCurrency(invoice.currency, due)
    },
    refreshInvoice () {
      this.requests.enrich.resourceId = this.selectedInvoice.id
      let appointments = this.selectedInvoice.appointments.join(',')
      this.requests.enrich.data = { appointments }
      this.$request('save', this.requests.enrich)
    }
  }
}
</script>

<style>
.v-list__tile__action.thin { min-width: 40px; }
.selected { background-color: grey; }
</style>



// WEBPACK FOOTER //
// InvoiceList.vue?51bc3fc5